var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "registerBox" }, [
        _c("div", { staticClass: "rightBox" }, [
          _c("div", { staticClass: "Requirement" }, [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("姓名")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name"
                }
              ],
              staticClass: "rigRe fr",
              attrs: { type: "text", placeholder: "请输入姓名" },
              domProps: { value: _vm.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Requirement" }, [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("电话")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.tel,
                  expression: "tel"
                }
              ],
              staticClass: "rigRe fr",
              attrs: {
                type: "number",
                placeholder: "请输入电话号码",
                pattern: "[0-9]*"
              },
              domProps: { value: _vm.tel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.tel = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "Determine",
              class: _vm.disabled === true ? "dis" : "",
              on: {
                click: function($event) {
                  _vm.disabled === true ? "" : _vm.clickApply()
                }
              }
            },
            [_vm._v("\n        激活\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.toast,
              expression: "toast"
            }
          ],
          staticClass: "toast"
        },
        [_vm._v(_vm._s(_vm.toastText))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f59535b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f59535b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/weixinBind/index.vue
// module id = null
// module chunks = 